import React, { FC } from 'react';
import { FieldErrorList, FormField, Input, Label, TextArea } from 'common/components';
import { InputType } from 'common/enums';
import { FieldError } from 'common/models';
import { RoleField } from 'modules/admin-roles-management/enums/admin-role.enum';
import './AdminRoleForm.scss';

type AdminRoleFormProps = {
    name: string;
    description: string;
    fieldErrors: Array<FieldError>;
    handleNameChange: (event: any) => void;
    handleDescriptionChange: (event: any) => void;
};

const AdminRoleForm: FC<AdminRoleFormProps> = ({
    name,
    description,
    fieldErrors,
    handleNameChange,
    handleDescriptionChange
}) => {
    return (
        <>
            <div className="admin-role-form-top-section">
                <FormField className="admin-role-form-field">
                    <Label text="Role Name (required)"></Label>
                    <Input
                        type={InputType.TEXT}
                        value={name}
                        onChange={handleNameChange}
                        onBlur={handleNameChange}
                    />
                    <FieldErrorList field={RoleField.Name} errors={fieldErrors} />
                </FormField>
            </div>
            <div>
                <FormField className="admin-role-form-field-right">
                    <Label text="Description"></Label>
                    <TextArea
                        value={description}
                        onChange={handleDescriptionChange}
                        onBlur={handleDescriptionChange}
                    />
                    <FieldErrorList field={RoleField.Description} errors={fieldErrors} />
                </FormField>
                <FieldErrorList field={RoleField.WRITE_WITHOUT_READ} errors={fieldErrors} />
            </div>
        </>
    );
};

export default AdminRoleForm;
